module.exports = __webpack_public_path__ + "static/media/mpn-logotype-l.27df1c18.svg";